import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const RetryPaymentLoadable = Loadable({
    loader: () => import('desktop/containers/RetryPayment/RetryPayment.js' /* webpackChunkName: 'retryPayment' */).then(module => module.default),
    loading: () => <Loader />
});

export default RetryPaymentLoadable;
